import React, { useCallback, useState } from 'react'
import { intl } from 'lang/intl'

import { TtButton } from '@23/react'

import { useJoinToSpeakAsHost } from '../../../../join-to-speak'

type AttendeeDemoterProps = {
  attendeeId: string
  attendeeName: string
}

const AttendeeDemoter = ({
  attendeeId,
  attendeeName,
}: AttendeeDemoterProps) => {
  const { handleAttendeeExpiration } = useJoinToSpeakAsHost()
  const [isDisabled, setIsDisabled] = useState(false)

  const onClick = useCallback(async () => {
    setIsDisabled(true)
    await handleAttendeeExpiration(attendeeId)
  }, [attendeeId, handleAttendeeExpiration])

  return (
    <div className="attendee-demoter">
      <TtButton
        size="small"
        color="danger"
        label={intl.formatMessage(
          {
            defaultMessage: 'Send {name} back to the audience',
          },
          { name: attendeeName }
        )}
        disabled={isDisabled}
        onClick={onClick}
      >
        {!isDisabled
          ? intl.formatMessage({
              defaultMessage: 'Remove',
            })
          : intl.formatMessage({
              defaultMessage: 'Removing...',
            })}
      </TtButton>
    </div>
  )
}

export { AttendeeDemoter }
